import { useEffect, useState } from "react";
import { Assets } from "../../../../../assets";
// import { GoBack } from "../../../../common/components/GoBack/GoBack";
import SalesOperationsCards from "../components/SalesOperationsCards";
// import { FaPlusSquare } from "react-icons/fa";
import style from "./style.module.scss";
import { Avatar, Divider, List, Progress } from "antd";
// import StaffCards from "./components/StaffCards";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router";
import { CommercialOperation, DetailService } from "../../../core/_request";
import { HttpStatusCode } from "axios";
import { FormatDate } from "../../../../../utilities/formatDate";
import { TitleHeader } from "../../../../../common/components/TitleHeader/TitleHeader";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { Container } from "../../../../../common/components/container/Container";
import { CustomCalendar } from "../../../../../common/components/Calendar/CustomCalendar";
import { EventContentArg } from "@fullcalendar/core";
import { MdOutlineEventBusy } from "react-icons/md";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { RiTeamFill } from "react-icons/ri";
import { CiSettings } from "react-icons/ci";

export const OperationDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [initialValue, setInitialValue] = useState<any>();
  const [isLoadingOperation, setIsLoadingOperation] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const [selectedTeam, setSelectedTeam] = useState<any>({});
  const [operationTypeValue, setOperationTypeValue] = useState<string>("");

 const isCabotage: boolean = window.location.pathname.includes('/cabotage/');

  const percent = initialValue?.dataKpi?.global?.percentage;

  useEffect(() => {
    id && fetchTeamOrder(+id);
  }, [id]);

  const fetchTeamOrder = async (id: number, params?: any) => {
    try {
      setIsLoadingOperation(true);
      const res = await CommercialOperation.getOneOperation(id, params);

      if (res?.status === HttpStatusCode.Ok) {
        // setTitle(res?.data?.reference);

        setInitialValue(
          formatData({
            ...res?.data,
          })
        );
        setOperationTypeValue(res?.data?.operationType?.name);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingOperation(false);
    }
  };
  const formatData = (data: any) => {
    const formattedData = {
      ...data,
      holdsValueLength: data?.holds?.length,
      receiptRequestAt: data?.receiptRequestAt
        ? FormatDate.dayjsFormat(data?.receiptRequestAt)
        : null,
      estimatedArrivalAt: data?.estimatedArrivalAt
        ? FormatDate.dayjsFormat(data?.estimatedArrivalAt)
        : null,
      startAt: data?.startAt ? FormatDate.dayjsFormat(data?.startAt) : null,
      endAt: data?.endAt ? FormatDate.dayjsFormat(data?.endAt) : null,
      teamOrderFile: data?.teamOrderFile
        ? {
            label: data?.teamOrderFile?.basename,
            value: data?.teamOrderFile?.["@id"],
          }
        : null,
      arrivalNoticeFile: data?.arrivalNoticeFile
        ? {
            label: data?.arrivalNoticeFile?.basename,
            value: data?.arrivalNoticeFile?.["@id"],
          }
        : null,
      embarkationPlanFile: data?.embarkationPlanFile
        ? {
            label: data?.embarkationPlanFile?.basename,
            value: data?.embarkationPlanFile?.["@id"],
          }
        : null,
      debarkationPlanFile: data?.debarkationPlanFile
        ? {
            label: data?.debarkationPlanFile?.basename,
            value: data?.debarkationPlanFile?.["@id"],
          }
        : null,
      customer: data?.customer
        ? {
            label: data?.customer?.name,
            value: data?.customer?.[`@id`],
          }
        : null,
      customerCategory: data?.customer
        ? {
            label: data?.customer?.customerCategory?.name,
            value: data?.customer?.customerCategory?.[`@id`],
          }
        : null,
      operationType: data?.operationType
        ? {
            label: data?.operationType?.name,
            value: data?.operationType?.["@id"],
          }
        : null,
      operationShifting: data?.operationShifting
        ? {
            label: data?.operationShifting?.name,
            value: data?.operationShifting?.["@id"],
          }
        : null,
      teamsDockside: data?.teamsDockside?.map((item: any) => ({
        ...item,
        ...(item.teamShiftStart ? 
          {
            teamShiftStart: FormatDate.dayjsTimeFormat(item.teamShiftStart),
          } : {}
        ),
        ...(item.teamShiftEnd ? 
          {
            teamShiftEnd: FormatDate.dayjsTimeFormat(item.teamShiftEnd),
          } : {}
        ),
        ...(item?.assignmentLocation
          ? {
              assignmentLocation: {
                label: item?.assignmentLocation?.name,
                value: item?.assignmentLocation?.["@id"],
              },
            }
          : {}),
      })),
      teamsOnBoard: data?.teamsOnBoard?.map((item: any) => ({
        ...item,
        ...(item.teamShiftStart ? 
          {
            teamShiftStart: FormatDate.dayjsTimeFormat(item.teamShiftStart),
          } : {}
        ),
        ...(item.teamShiftEnd ? 
          {
            teamShiftEnd: FormatDate.dayjsTimeFormat(item.teamShiftEnd),
          } : {}
        ),
      })),
      teamsStorage: data?.teamsStorage?.map((item: any) => ({
        ...item,
        ...(item.teamShiftStart ? 
          {
            teamShiftStart: FormatDate.dayjsTimeFormat(item.teamShiftStart),
          } : {}
        ),
        ...(item.teamShiftEnd ? 
          {
            teamShiftEnd: FormatDate.dayjsTimeFormat(item.teamShiftEnd),
          } : {}
        ),
      })),
    };

    return formattedData;
  };

  // loads
  const loadsTxt = initialValue?.loadsTxt ?? "";

  const hasContainer = loadsTxt?.includes("Conteneur");
  const hasBag = loadsTxt?.includes("Sac");

  const isEmbarkation = operationTypeValue === "Embarquement";
  const isDebarkation = operationTypeValue === "Débarquement";
  const isBoth = operationTypeValue === "Débarquement & Embarquement";

  const formatListData = (data: any) => {
    return data?.map((item: any) => ({
      ...item,
      teamId: item?.id,
      time: item?.teamShift
        ? `${item?.teamShift?.start} - ${item?.teamShift?.end}`
        : "",
      start: item?.createdAt
        ? dayjs(item?.createdAt, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD")
        : null,
    }));
  };

  const onOpenDrawerHandler = () => {
    setIsOpenDrawer((prev: boolean) => {
      return !prev;
    });
  };

  const handleClickOnTeam = async (teamId: number) => {
    try {
      setIsLoading(true);
      const res = await DetailService.getStaffs(teamId);
      if (res?.status === HttpStatusCode.Ok) {
        setSelectedTeam(res?.data);
        onOpenDrawerHandler();
      }
    } catch (_: any) {
    } finally {
      setIsLoading(false);
    }
  };

  const onRedirect = () => {
    //const movement = initialValue?.debarkationMovement?.['@id'].split('/').pop() || initialValue?.embarkationMovement?.['@id'].split('/').pop();
    navigate(`../operation/${id}`)
  }

  const renderValue = (...paths: string[]) => {
    for (const path of paths) {
      const value = path
        .split(".")
        .reduce((obj, key) => obj?.[key], initialValue);
  
      if (value != null) {
        // 1. check if date
        const date = new Date(value);
        const isDate =
          typeof value !== "number" &&
          !isNaN(date.getTime()) &&
          (typeof value === "string" ? value.length > 5 : true);
  
        if (isDate) {
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
  
          return `${day}/${month}/${year} ${hours}:${minutes}`;
        }
  
        // 2. if not date
        const text = String(value);
        return text.length > 30 ? `${text.slice(0, 30)}...` : text;
      }
    }
  
    return "-";
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      {isLoadingOperation ? (
        <Loader isLoading={isLoadingOperation} />
      ) : (
        <div className="">
          <TitleHeader
            title=""
            isSHowBack
            subTitle={`${initialValue?.reference ?? ""}`}
          />
          <div className={style.buttonWrapper}>
            <div className={style.buttonLike} onClick={onRedirect}>
              <CiSettings size={22} />
              Paramétrage
            </div>
          </div>          
          <Container>
          <div className={style.details}>
            <div className={style.details__container}>
              {/* Ligne 1 — Carte opération */}
              <div className={style.details__grid_item}>
                <SalesOperationsCards className={style.details__card_container}>
                  <div className="d-flex gap-4">
                    <div className={style.details__image_wrapper}>
                      <img
                        src={Assets.images.ships}
                        className={style.image}
                        alt=""
                      />
                    </div>

                    <div className={style.details__card_title_wrapper}>
                      <span className={style.details__card_title}>
                        {initialValue?.reference}
                      </span>

                      <span className={style.details__card_text}>
                        {`ETA ${dayjs(
                          initialValue?.estimatedArrivalAt,
                          "DD/MM/YYYY"
                        ).format("DD/MM/YYYY")}`}
                      </span>

                      <span className={style.details__card_text}>
                        {operationTypeValue}
                      </span>

                      <span className={style.details__card_text}>
                        Marchandise :{" "}
                        {initialValue?.loadsTxt ? (
                          initialValue.loadsTxt
                        ) : (
                          <i style={{ fontStyle: "italic", opacity: 0.8 }}>
                            En attente de manifeste.
                          </i>
                        )}
                      </span>
                    </div>
                  </div>

                  <button
                    className={style.details__footer_button}
                    onClick={() =>
                      navigate(
                        `/app/operations/sales-operations/operation/${id}/operation-folders`
                      )
                    }
                  >
                    <span>
                      <img src={Assets.images.file} alt="" />
                      Documents liés
                    </span>
                  </button>
                </SalesOperationsCards>
              </div>

              {/* Ligne 1 — Avancement global */}
              <div className={style.details__grid_item}>
              <SalesOperationsCards
                className={style.details__card_container}
                title="Avancement global"
                icon={<img src={Assets.images.diagram} alt="" />}
              >
                  <div className={style.details__progress}>
                    <Progress size={100} type="circle" percent={percent} />
                  </div>
                </SalesOperationsCards>
              </div>

              {/* Ligne 2 — Commande Équipe */}
              <div className={style.details__grid_item}>
                <SalesOperationsCards
                  title="Commande Equipe"
                  className={style.details__card_container}
                >
                  <div className={style.details__summary}>
                    <p className={style.details__section_title}>
                      Suivi de l'opération
                    </p>

                    <div className={style.details__card_item}>
                      <span className={style.details__label}>
                        Début de l'opération
                      </span>
                      <span className={style.details__value}>
                        {renderValue("startAt")}
                      </span>
                    </div>

                    <div className={style.details__card_item}>
                      <span className={style.details__label}>
                        Fin de l’opération
                      </span>
                      <span className={style.details__value}>
                        {renderValue("endAt")}
                      </span>
                    </div>
                    {(hasContainer || hasBag) && (
                      <div className={style.details__movements}>
                        {/* Débarquement */}
                        {(isDebarkation || isBoth) && (
                          <div className={style.details__movement_group}>
                            <p className={style.details__movement_title}>
                              Débarquement
                            </p>

                            {hasContainer && (
                              <div className={style.details__movement_section}>
                                <span className={style.details__movement_label}>
                                  Conteneurs
                                </span>

                                <div className={style.details__movement_stats}>
                                  <div className={style.details__movement_stat}>
                                    <span>Pleins</span>
                                    <strong>
                                      {renderValue("debarkationMovement.filledCount")}
                                    </strong>
                                  </div>

                                  <div className={style.details__movement_stat}>
                                    <span>Vides</span>
                                    <strong>
                                      {renderValue("debarkationMovement.emptyCount")}
                                    </strong>
                                  </div>

                                  <div className={style.details__movement_stat}>
                                    <span>Restants</span>
                                    <strong>
                                      {renderValue(
                                        "debarkationMovement.remainingContainerCount"
                                      )}
                                    </strong>
                                  </div>
                                </div>
                              </div>
                            )}

                            {hasBag && (
                              <div className={style.details__movement_section}>
                                <span className={style.details__movement_label}>
                                  Sacherie
                                </span>

                                <div className={style.details__movement_stats}>
                                  <div className={style.details__movement_stat}>
                                    <span>Tonnage total</span>
                                    <strong>
                                      {renderValue(
                                        "debarkationMovement.totalBagTonnage"
                                      )} T
                                    </strong>
                                  </div>

                                  <div className={style.details__movement_stat}>
                                    <span>Tonnage restant</span>
                                    <strong>
                                      {renderValue(
                                        "debarkationMovement.remainingBagTonnage"
                                      )} T
                                    </strong>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Embarquement */}
                        {(isEmbarkation || isBoth) && (
                          <div className={style.details__movement_group}>
                            <p className={style.details__movement_title}>
                              Embarquement
                            </p>

                            {hasContainer && (
                              <div className={style.details__movement_section}>
                                <span className={style.details__movement_label}>
                                  Conteneurs
                                </span>

                                <div className={style.details__movement_stats}>
                                  <div className={style.details__movement_stat}>
                                    <span>Pleins</span>
                                    <strong>
                                      {renderValue("embarkationMovement.filledCount")}
                                    </strong>
                                  </div>

                                  <div className={style.details__movement_stat}>
                                    <span>Vides</span>
                                    <strong>
                                      {renderValue("embarkationMovement.emptyCount")}
                                    </strong>
                                  </div>

                                  <div className={style.details__movement_stat}>
                                    <span>Restants</span>
                                    <strong>
                                      {renderValue(
                                        "embarkationMovement.remainingContainerCount"
                                      )}
                                    </strong>
                                  </div>
                                </div>
                              </div>
                            )}

                            {hasBag && (
                              <div className={style.details__movement_section}>
                                <span className={style.details__movement_label}>
                                  Sacherie
                                </span>

                                <div className={style.details__movement_stats}>
                                  <div className={style.details__movement_stat}>
                                    <span>Tonnage total</span>
                                    <strong>
                                      {renderValue(
                                        "embarkationMovement.totalBagTonnage"
                                      )} T
                                    </strong>
                                  </div>

                                  <div className={style.details__movement_stat}>
                                    <span>Tonnage restant</span>
                                    <strong>
                                      {renderValue(
                                        "embarkationMovement.remainingBagTonnage"
                                      )} T
                                    </strong>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className={style.details__subsection}>
                  <p className={style.details__section_title}>
                    Informations de la demande
                  </p>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Référence : </span>
                    <span className={style.details__value}>{renderValue("reference")}</span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>
                      Date de réception de la demande :{" "}
                    </span>
                    <span className={style.details__value}>
                      {renderValue("receiptRequestAt")}
                    </span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Client : </span>
                    <span className={style.details__value}>
                      {renderValue("customer.label")}
                    </span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>
                      Pièce jointe (Commande équipe) :{" "}
                    </span>
                    <span className={style.details__value}>
                      {renderValue("teamOrderFile.label")}
                    </span>
                  </div>
                  {!isCabotage && (
                    <div className={style.details__card_item}>
                    <span className={style.details__label}>
                      Pièce jointe (Avis d'arrivée) :{" "}
                    </span>
                    <span className={style.details__value}>
                      {renderValue("arrivalNoticeFile.label")}
                    </span>
                  </div>
                  )}
                  </div>
                  <div className={style.details__subsection}>
                  <p className={style.details__section_title}>
                    Opérations liées
                  </p>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Navire(s) à opérer : </span>
                    <span className={style.details__value}>{renderValue("ship")}</span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Nombre de cales : </span>
                    <span className={style.details__value}>
                      {renderValue("holdsValueLength")}
                    </span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Référence du voyage : </span>
                    <span className={style.details__value}>
                      {renderValue("travelReference")}
                    </span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Port de provenance : </span>
                    <span className={style.details__value}>{renderValue("origin")}</span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Date de départ estimée : </span>
                    <span className={style.details__value}>
                      {renderValue("estimatedDepartureAt")}
                    </span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Port de destination : </span>
                    <span className={style.details__value}>{renderValue("destination")}</span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Date d'arrivée estimée : </span>
                    <span className={style.details__value}>
                      {renderValue("estimatedArrivalAt")}
                    </span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>
                      Second port de destination :{" "}
                    </span>
                    <span className={style.details__value}>
                      {renderValue("secondaryDestination")}
                    </span>
                  </div>
                  <div className={style.details__card_item}>
                    <span className={style.details__label}>Début d'opération estimée : </span>
                    <span className={style.details__value}>
                      {renderValue("estimatedOperationsStartAt")}
                    </span>
                  </div>
                  </div>
                </SalesOperationsCards>
              </div>

              {/* Ligne 2 — Manifeste */}
              <div className={style.details__grid_item}>
                <SalesOperationsCards
                  title="Manifeste"
                  className={style.details__card_container}
                >
                  <div className={style.details__manifesto_details_section}>
                    <div className={style.details__card_item}>
                      <span className={style.details__label}>Armateur : </span>
                      <span className={style.details__value}>
                        {renderValue(
                          "debarkationMovement.customerShipowner.name",
                          "debarkationMovement.customerShipowner.name"
                        )}
                      </span>
                    </div>
                    <div className={style.details__card_item}>
                      <span className={style.details__label}>
                        Total de mouvements prévus :{" "}
                      </span>
                      <span className={style.details__value}>
                        {renderValue("debarkationMovement.movementCount", "embarkationMovement.movementCount")}
                      </span>
                    </div>
                    {(isDebarkation || isBoth) && (
                      <div className={style.details__movement_group}>
                        <p className={style.details__movement_title}>
                          Débarquement
                        </p>

                        <div className={style.details__card_item}>
                          <span className={style.details__label}>
                            Total de mouvements restants
                          </span>

                          <span className={style.details__value}>
                            {renderValue("debarkationMovement.remainingCount")}
                          </span>
                        </div>

                        <div className={style.details__card_item}>
                          <span className={style.details__label}>Additif</span>

                          <span className={style.details__value}>
                            {renderValue("debarkationMovement.additiveCount")}
                          </span>
                        </div>

                        <div className={style.details__card_item}>
                          <span className={style.details__label}>
                            Total non débarqué
                          </span>

                          <span className={style.details__value}>
                            {renderValue("debarkationMovement.notDebarkedCount")}
                          </span>
                        </div>
                      </div>
                    )}
                    
                    {(isEmbarkation || isBoth) && (
                      <div className={style.details__movement_group}>
                        <p className={style.details__movement_title}>
                          Embarquement
                        </p>

                        <div className={style.details__card_item}>
                          <span className={style.details__label}>
                            Total de mouvements restants
                          </span>

                          <span className={style.details__value}>
                            {renderValue("embarkationMovement.remainingCount")}
                          </span>
                        </div>

                        <div className={style.details__card_item}>
                          <span className={style.details__label}>Additif</span>

                          <span className={style.details__value}>
                            {renderValue("embarkationMovement.additiveCount")}
                          </span>
                        </div>

                        <div className={style.details__card_item}>
                          <span className={style.details__label}>
                            Total non débarqué
                          </span>

                          <span className={style.details__value}>
                            {renderValue("embarkationMovement.notDebarkedCount")}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </SalesOperationsCards>
              </div>
            </div>
          </div>

            <div className="mx-2 p-4 detail-perso" style={{marginTop: "25px"}}>
              <CustomCalendar
                onClick={(e: any) => {
                  console.log(e);
                }}
                events={formatListData(initialValue?.allTeamsArray)}
                renderContent={(e: EventContentArg) => {
                  const time = e.event.extendedProps.time;
                  const isValidTime = time && time !== "null-null" && time !== "null - null" && time !== "null";
                  return (
                  <div
                    className={"calendar__event"}
                    style={{
                      padding: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleClickOnTeam(e?.event?.extendedProps?.teamId);
                    }}
                  >
                    <div className={"calendar__event_icon"}>
                      <MdOutlineEventBusy size={20} />
                    </div>
                    <div className="d-flex flex-column ">
                      <span className={"calendar__event_title"}>
                        {e?.event?.extendedProps?.name}
                      </span>

                      {isValidTime && (
                        <span className={"calendar__event_title"}>
                        {e.event.extendedProps.time}
                      </span>
                      )}
                    </div>
                  </div>
                  )
                }}
              />
            </div>
          </Container>

          {isOpenDrawer ? (
            <CustomDrawer
              isOpen={isOpenDrawer}
              onClose={onOpenDrawerHandler}
              width={600}
              title={`${selectedTeam?.name}`}
            >
              <div
                className="d-flex gap-2 align-items-center justify-content-center pb-2"
                style={{
                  borderBottom: "dashed 1px #EEEEEE",
                  color: "#58A0C8",
                }}
              >
                <RiTeamFill
                  style={{
                    fontSize: "25px",
                  }}
                />
                <div className="">
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    {selectedTeam?.teamType?.name}{" "}
                  </span>
                </div>
              </div>
              <div className="d-flex gap-4 flex-column">
                {selectedTeam?.allStaffs?.map((staffPost: any) => (
                  <div>
                    <Divider orientation="left" plain>
                      <span> {staffPost?.post} </span>
                    </Divider>

                    <List
                      itemLayout="horizontal"
                      dataSource={staffPost?.names}
                      renderItem={(item: string, index) => (
                        <List.Item key={index}>
                          <List.Item.Meta
                            avatar={
                              <Avatar style={{ backgroundColor: "#58A0C8" }}>
                                {[...item?.split("")][0]}
                              </Avatar>
                            }
                            description={item}
                          />
                        </List.Item>
                      )}
                    />
                  </div>
                ))}
              </div>
            </CustomDrawer>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};
